<template>
  <div>
    <h1>Create Collection</h1>
    <p>This is a placeholder page for creating a new collection.</p>
  </div>
</template>

<script>
export default {
  name: 'CollectionCreate',
};
</script>
